import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.link.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/discuss/meeting-cover.png';
var _hoisted_1 = {
  class: "meeting-panel"
};
var _hoisted_2 = {
  class: "main"
};
var _hoisted_3 = {
  key: 0,
  class: "meeting-list"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "title"
};
var _hoisted_6 = ["onClick"];
import SideBar from './common/SideBar';
import Empty from './common/Empty';

/* 工具 */
import { ref, reactive, inject, computed, onMounted } from 'vue';
import { DialogPlugin, MessagePlugin } from 'tdesign-vue-next';
import { operationRecord } from './common/common';
import { LEFT_BAR_MAP } from '../const';
import { getStore } from '@/util/store';
import { debounce } from '@/util/index';

/* api */
import { addMeeting, checkMeetingUrl, getMeetingList, delMeeting as delMeetingApi } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'Meeting',
  setup: function setup(__props) {
    /* 组件 */
    var discussId = inject('discussId');
    var discussInfo = inject('discussInfo');
    var form = ref();
    var rules = {
      theme: [{
        required: true
      }],
      link: [{
        required: true
      }]
    };
    var state = reactive({
      meetingList: [],
      addMeetingShow: false,
      formData: {
        theme: '',
        link: ''
      }
    });

    /* 计算属性 */
    // 当前是否为创建者
    var isCreator = computed(function () {
      var _discussInfo$value;
      var userInfo = getStore({
        name: 'userInfo'
      });
      return userInfo.id === ((_discussInfo$value = discussInfo.value) === null || _discussInfo$value === void 0 ? void 0 : _discussInfo$value.creatorId);
    });

    /* 事件 */
    // 侧边栏点击
    var sideBarChange = function sideBarChange(item) {
      if (item.click === 'meetingAdd') {
        state.addMeetingShow = true;
      }
    };

    // 关闭弹窗
    var onClose = function onClose() {
      form.value.reset();
      state.addMeetingShow = false;
    };

    // 弹窗确认
    var onConfirm = debounce(function () {
      form.value.submit();
    });

    // 获取列表
    var getList = function getList() {
      getMeetingList(discussId.value).then(function (res) {
        if (res.data.code === 0) {
          state.meetingList = res.data.data || [];
        }
      });
    };

    // 检查会议地址
    var checkUrl = function checkUrl() {
      return new Promise(function (resolve) {
        var num = Number(state.formData.link);
        var isNum = !isNaN(num);
        if (isNum) {
          resolve(false);
        } else {
          checkMeetingUrl(discussId.value, {
            url: state.formData.link
          }).then(function (res) {
            if (res.data.code === 0) {
              resolve(res.data.data === 0);
            }
          });
        }
      });
    };

    // 提交
    var onSubmit = function onSubmit() {
      form.value.validate().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(result) {
          var _Object$values$, firstError, isEffectUrl, data;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (result && Object.keys(result).length) {
                  firstError = (_Object$values$ = Object.values(result)[0]) === null || _Object$values$ === void 0 || (_Object$values$ = _Object$values$[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.message;
                  MessagePlugin.warning(firstError);
                }
                if (!(result === true)) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return checkUrl();
              case 1:
                isEffectUrl = _context.v;
                if (isEffectUrl) {
                  data = {
                    discussId: discussId.value,
                    name: state.formData.theme,
                    url: state.formData.link
                  };
                  addMeeting(data).then(function (res) {
                    if (res.data.code === 0) {
                      MessagePlugin.success('添加成功！');
                      getList();
                      onClose();
                    }
                  });
                } else {
                  MessagePlugin.warning('请输入有效地址！');
                }
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    };

    // 删除会议
    var delMeeting = function delMeeting(id) {
      var dialog = DialogPlugin({
        header: '删除会议/直播',
        body: '是否删除该会议/直播',
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function onConfirm() {
          delMeetingApi(discussId.value, id).then(function (res) {
            if (res.data.code === 0) {
              MessagePlugin.success('删除成功！');
              dialog.destroy();
              getList();
            }
          });
        }
      });
    };

    // 跳转详情
    var toDetail = function toDetail(item) {
      if (item.url) {
        operationRecord(discussId.value, '查看会议/直播');
        window.open(item.url);
      }
    };

    /* 钩子 */
    onMounted(function () {
      getList();
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_form_item = _resolveComponent("t-form-item");
      var _component_t_form = _resolveComponent("t-form");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(SideBar), {
        barList: _unref(LEFT_BAR_MAP)['meeting'],
        onTabChange: sideBarChange
      }, null, 8, ["barList"]), _createElementVNode("div", _hoisted_2, [state.meetingList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.meetingList, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "meeting-item",
          onClick: function onClick($event) {
            return toDetail(item);
          }
        }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "cover"
        }, [_createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(item.name), 1)]), isCreator.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "delete",
          onClick: _withModifiers(function ($event) {
            return delMeeting(item.id);
          }, ["stop"])
        }, [_createVNode(_component_svg_icon, {
          class: "icon",
          name: "delete-white"
        })], 8, _hoisted_6)) : _createCommentVNode("", true)], 8, _hoisted_4);
      }), 128))])) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        name: "meeting"
      })), _createVNode(_component_t_dialog, {
        visible: state.addMeetingShow,
        "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
          return state.addMeetingShow = $event;
        }),
        header: "添加会议/直播",
        class: "add-dialog",
        width: "480px",
        placement: "center",
        onConfirm: _unref(onConfirm)
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_form, {
            ref_key: "form",
            ref: form,
            data: state.formData,
            rules: rules,
            "label-align": "top",
            onSubmit: onSubmit
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_form_item, {
                label: "主题",
                name: "theme"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_t_input, {
                    modelValue: state.formData.theme,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return state.formData.theme = $event;
                    }),
                    placeholder: "请输入主题",
                    maxlength: "20"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_t_form_item, {
                label: "邀请链接",
                name: "link"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_t_input, {
                    modelValue: state.formData.link,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return state.formData.link = $event;
                    }),
                    placeholder: "请输入会议邀请链接"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["data"])];
        }),
        _: 1
      }, 8, ["visible", "onConfirm"])])]);
    };
  }
};